<div style="display: flex; flex-direction: column; gap: 1rem">
  <h2>Something's wrong here...</h2>
  <span>We cant find the page you're looking for.</span>
  <div style="display: flex; gap: 1rem">
    <goab-button type="secondary" (onClick)="goBack()">Back</goab-button>
    <goab-button type="primary" (onClick)="goHome()">Home</goab-button>
  </div>
</div>
